import { render } from "./Deposits.vue?vue&type=template&id=fe66edf4&ts=true"
import script from "./Deposits.vue?vue&type=script&lang=ts"
export * from "./Deposits.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__